import { useSelector } from 'react-redux';
import type { UserOrganisation } from '../../types/types';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import purpleBackground from '../../assets/PurpleBackground2.png';

export default function DashboardComponent() {
  const selectedOrganisation = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => state.organisation.selected
  ) as UserOrganisation | undefined;
  return (
    <Container
      fluid
      className="p-5"
      style={{
        backgroundImage: `url(${purpleBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        borderRadius: '24px',
      }}
    >
      <h2 className="text-white mb-5">
        Dashboard for {selectedOrganisation?.organisation?.name}
      </h2>
      <Row className="mt-3">
        <Col md={3}>
          <Card
            className="h-100"
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '24px',
            }}
          >
            <Card.Body className="text-white">
              <p>Invite suppliers in bulk using an onboarding quitionnaire</p>
              <Button
                variant="outline-light"
                className="w-100 text-nowrap"
                size="lg"
              >
                Invite suppliers
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card
            className="h-100"
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '24px',
            }}
          >
            <Card.Body className="text-white">
              <p>Send CSDDD qustionnaire to selected suppliers</p>
              <Button
                variant="outline-light"
                className="w-100 text-nowrap"
                size="lg"
              >
                Send CSDDD qustionnaire
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card
            className="h-100"
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '24px',
            }}
          >
            <Card.Body className="text-white">
              <p>Send ESG qustionnaire to selected suppliers</p>
              <Button
                variant="outline-light"
                className="w-100 text-nowrap"
                size="lg"
              >
                Send ESG qustionnaire
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3}>
          <Card
            className="h-100"
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '24px',
            }}
          >
            <Card.Body className="text-white">
              <p>Send LkSG qustionnaire to selected suppliers</p>
              <Button
                variant="outline-light"
                className="w-100 text-nowrap"
                size="lg"
              >
                Send LkSG qustionnaire
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
